import React, { FC } from 'react';
import { Text } from 'react-native';
import i18n from 'i18n-js';

import { font as initialFont } from '@styles/fonts';
import { WithColor } from '@styles/colors';
import Image from '@v2/context/Image/context';
import { SmallLoading } from '@components/loading';
import { buildJobThumbnailImageProps } from '@v2/components/FinishJobModal/helpers';
import type { WithScaleFont } from '@interfaces/base';

export interface JobThumbnailProps extends WithColor, Pick<WithScaleFont, 'font'> {
  imageProps: ReturnType<typeof buildJobThumbnailImageProps>;
  isImageLoading: boolean;
}

// Three mutually exclusive states: resolved image, in-flight spinner, or empty placeholder.
const JobThumbnail: FC<JobThumbnailProps> = ({ C, imageProps, isImageLoading, font = initialFont }) => {
  if (imageProps) return <Image {...imageProps} />;
  if (isImageLoading) return <SmallLoading />;
  return <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('No image')}</Text>;
};

export default JobThumbnail;
